import { render, staticRenderFns } from "./BronzeAgeArticle.vue?vue&type=template&id=38123a03&"
import script from "./BronzeAgeArticle.vue?vue&type=script&lang=js&"
export * from "./BronzeAgeArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports